import { SignalQuiz } from "@/components/site/SignalQuiz";
import { useSeo } from "@/lib/useSeo";
import { pageSchema } from "@/lib/schema";

export default function Quiz() {
  useSeo("Signal or noise? The 60-second quiz", "Five quick questions to find out whether you follow market noise or real signals.",
    pageSchema("WebPage", "Signal or noise? The 60-second quiz", "/quiz", "Five quick questions to find out whether you follow market noise or real signals."));
  return (
    <main data-testid="quiz-page" className="mx-auto max-w-3xl px-6 pb-24 pt-28 md:px-12 md:pt-36">
      <p className="eyebrow">60-second quiz</p>
      <h1 className="font-display mt-5 text-4xl font-medium leading-tight tracking-tight text-white md:text-6xl">
        Do you follow the noise <span className="font-serif-i text-zinc-400">or the signal?</span>
      </h1>
      <div className="mt-14"><SignalQuiz /></div>
    </main>
  );
}
